import Vuex from "vuex";
import Vue from "vue";
import authStore from "./modules/auth";
import reviewStore from "./modules/review";
import operatorStore from "./modules/operator";
import quoteStore from "./modules/quote";
import packageStore from "./modules/package";
import blogStore from "./modules/blog";
import destinationStore from "./modules/destination";
import landingPageStore from "./modules/landing-page";
import documentTypeStore from "./modules/document-type";
import customStore from "./modules/custom";
import tourStore from "./modules/tour";
import galleryStore from "./modules/gallery";
import settingStore from "./modules/setting";
import paymentStore from "./modules/payment";
import accommodationStore from "./modules/accommodation";
import placeStore from "./modules/place-to-visit";
import thingsStore from "./modules/things-to-do";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    customStore,
    authStore,
    reviewStore,
    operatorStore,
    quoteStore,
    packageStore,
    blogStore,
    tourStore,
    galleryStore,
    destinationStore,
    landingPageStore,
    documentTypeStore,
    settingStore,
    paymentStore,
    accommodationStore,
    placeStore,
    thingsStore,

  },
});
